
export enum TrpcService {
  AuthService = 'trpc.rmonitor.login_server.Auth',
  UserService = 'trpc.rmonitor.product_manager.User',
  ProductUserService = 'trpc.rmonitor.product_manager.ProductUser',
  ApprovalService = 'trpc.rmonitor.product_manager.Approval',
  RoleService = 'trpc.rmonitor.product_manager.Role',
  UserRoleService = 'trpc.rmonitor.user_manager.UserRoleAuth',
  BasicService = 'trpc.rmonitor.web_server.Basic',
  AppManagerService = 'trpc.rmonitor.manage_server.AppManage',
  StrategyService = 'trpc.rmonitor.alert_config.Strategy',
  AlertService = 'trpc.rmonitor.alert_server.Alert',
  IssueListService = 'trpc.rmonitor.web_server.IssueList',
  TrafficService = 'trpc.rmonitor.web_server.Traffic',
  MetricService = 'trpc.rmonitor.metrics_server.GetMetrics',
  ClusterService = 'trpc.eff_tool.excep_issue_cluster_ongo.ExcepIssueCluster',
  BatteryElementsService = 'trpc.rmonitor.web_server.BatteryElements',
  BatteryProblemService = 'trpc.rmonitor.web_server.BatteryProblem',
  DiagnoseService = 'trpc.rconfig.diagnose_cgi.DiagnoseMgr',
  IssueNoteService = 'trpc.rmonitor.manage_server.IssueNote',
  ExceptionService = 'trpc.rmonitor.web_server.Exception',
  SymbolUploadGatewayService = 'trpc.eff_tool.symbol_upload_gateway.SymbolUploadGateway',
  NetHttpService = 'trpc.rmonitor.web_server.NetworkHttp',
  MemoryService = 'trpc.rmonitor.web_server.MemoryDetail',
  RumService = 'trpc.rmonitor.web_server.RumService',
  ConfigService = 'trpc.rmonitor.manage_server.AppDeliverConfig',
  DebugDeviceService = 'trpc.rmonitor.product_manager.DebugDevice',
  LagService = 'trpc.rmonitor.web_server.LagProblem',
  ContinuousEvent = 'trpc.rmonitor.manage_server.ContinuousEvent',
  AiCopilotService = 'trpc.rmonitor.ai_server.AiServer',
  ProductOAServer = 'trpc.rmonitor.product_manager.ProductOa',
  QualityReportService = 'trpc.rmonitor.manage_server.QualityReport',
  ProductService = 'trpc.rmonitor.product_manager.Product',
  ResourcePackageService = 'trpc.buglyqq.resource_manager.Resource',
  OrderService = 'trpc.buglyqq.order_manager.OrderManager',
  ActivitiesService = 'trpc.rmonitor.product_manager.Activities',
  CouponService = 'trpc.buglyqq.resource_manager.Coupon',
  OverviewService = 'trpc.rmonitor.metrics_server.Overview',
  FilterRuleService = 'trpc.rmonitor.manage_server.FilterRule',
  ProductPermission = 'trpc.rmonitor.product_manager.ProductPermissions',
  VersionOperateService = 'trpc.rmonitor.manage_server.ProductVersion',
  AdvanceSearchService = 'trpc.rmonitor.web_server.AdvanceSearch',
  ExportHistoryService = 'trpc.rmonitor.product_manager.OperationHistory',
  RetCodeManageService = 'trpc.rmonitor.manage_server.RetCodeManage',
  ProductServer = 'trpc.rmonitor.product_manager.Product',
  SymbolOpenDataService = 'trpc.eff_tool.symbol_open_data.SymbolOpenData',
  CPUProblemService = 'trpc.rmonitor.web_server.CpuProblem',
  CustomEventService = 'trpc.rmonitor.manage_server.CustomEvent',
  DashboardService = 'trpc.rmonitor.manage_server.DashboardManage',
  AgentService = 'trpc.rmonitor.ai_server.Agent',
}
